import { useEffect, useState } from "react";
import { Globe, MessageCircle } from "lucide-react";
import { API } from "@/lib/api";
import { DEFAULT_DESCRIPTION, SITE_NAME } from "@/components/shared/Seo";

const imageId = (ref = "") => (String(ref).match(/\/api\/images\/([0-9a-f-]{36})/i) || [])[1] || null;
const useDebounced = (v, ms = 500) => { const [d, setD] = useState(v); useEffect(() => { const t = setTimeout(() => setD(v), ms); return () => clearTimeout(t); }, [v, ms]); return d; };

/** Live preview of the front page as a Google result and as a shared card – driven by the draft values. */
export const SeoPreview = ({ description, image }) => {
  const title = `${SITE_NAME} – huset eigd av folket på Halsnøy`;
  const desc = (description || "").trim() || DEFAULT_DESCRIPTION;
  const host = typeof window !== "undefined" ? window.location.host : "halsnoykulturhus.no";
  const imgId = useDebounced(imageId(image));
  const q = new URLSearchParams({ t: SITE_NAME, s: "Sæbøvik · Halsnøy" });
  if (imgId) q.set("img", imgId);
  const card = `${API}/og/card.jpg?${q.toString()}`;
  return (
    <div className="grid gap-4 lg:grid-cols-2" data-testid="seo-preview">
      <div className="rounded-xl bg-background p-4 ring-1 ring-foreground/[0.06]" data-testid="seo-preview-google">
        <p className="t-mono-sm mb-3 flex items-center gap-1.5 text-muted-foreground"><Globe className="h-3.5 w-3.5" /> Google</p>
        <div className="flex items-center gap-2 text-[12px] text-muted-foreground"><span className="flex h-6 w-6 items-center justify-center rounded-full bg-sol text-[10px] font-bold text-ink">H</span><span><span className="block text-[13px] text-foreground">{SITE_NAME}</span>{host}</span></div>
        <p className="mt-1.5 truncate font-sans text-[18px] leading-snug text-[#1a0dab] dark:text-[#8ab4f8]">{title}</p>
        <p className="mt-1 line-clamp-2 text-[13.5px] leading-snug text-muted-foreground">{desc}</p>
        <p className="mt-2 text-[11.5px] text-muted-foreground">{desc.length} teikn{desc.length > 155 ? " · Google kuttar truleg etter ~155" : ""}</p>
      </div>
      <div className="overflow-hidden rounded-xl bg-background ring-1 ring-foreground/[0.06]" data-testid="seo-preview-social">
        <p className="t-mono-sm flex items-center gap-1.5 px-4 pt-4 text-muted-foreground"><MessageCircle className="h-3.5 w-3.5" /> Facebook / Messenger / SMS</p>
        <img key={card} src={card} alt="Delingsbilete for framsida" className="mt-3 aspect-[1200/630] w-full bg-secondary object-cover" data-testid="seo-preview-card-image" />
        <div className="bg-secondary/60 px-4 py-3">
          <p className="t-mono-sm text-muted-foreground uppercase">{host}</p>
          <p className="truncate text-[14px] font-semibold">{title}</p>
          <p className="truncate text-[12.5px] text-muted-foreground">{desc}</p>
        </div>
      </div>
    </div>
  );
};
